import { mapState } from "vuex";
import { Formio } from "formiojs";

export default {
  computed: {
    ...mapState(["formioToken"]),
  },
  methods: {
    async getLatestSubmission(formioURL, enrollmentApplicationId) {
      const submissionFilter =
        "/exists?data.application_id=" + enrollmentApplicationId;
      return fetch(formioURL + submissionFilter, {
        headers: { "x-jwt-token": this.formioToken },
      })
        .then(response => response.json())
        .then(submissions => {
          let submissionId = "";
          if (Object.prototype.hasOwnProperty.call(submissions, "_id")) {
            submissionId = submissions._id;
          }
          return submissionId;
        })
        .catch(error => {
          console.log("error", error);
          return "";
        });
    },
    async existsByQuery(formURL, query) {
      let exists = false;
      return fetch(formURL + "/exists?" + query)
        .then(response => response.json())
        .then(submissions => {
          if (Object.prototype.hasOwnProperty.call(submissions, "_id")) {
            exists = submissions._id;
          }
          return exists;
        })
        .catch(() => {
          return exists;
        });
    },
    async sendSubmission(formURL, data, login) {
      const copyError = login
        ? "Something went wrong while trying to create the account, please try later."
        : "Something went wrong while submitting the form, please try later.";
      let requestOptions = {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(data),
        redirect: "follow",
      };
      let response = null;
      let sendSubmissionError = null;

      if (!login) requestOptions.headers["x-jwt-token"] = this.formioToken;

      try {
        response = await fetch(formURL + "/submission", requestOptions);
      } catch (err) {
        throw copyError;
      }

      if (response.status !== 200) {
        let error = await response.text();
        try {
          const errorJson = JSON.parse(error);
          sendSubmissionError = errorJson.details[0].message
            ? errorJson.details[0].message.lenght
            : copyError;
          throw sendSubmissionError;
        } catch (err) {
          sendSubmissionError = sendSubmissionError
            ? sendSubmissionError
            : error;
          throw sendSubmissionError;
        }
      } else {
        let submission = await response.json();

        if (login) Formio.setToken(response.headers.get("x-jwt-token"));

        return submission;
      }
    },
  },
};